import { createFileRoute } from '@tanstack/react-router';
import { SpacesPage } from '@/features/spaces/pages/spaces-page';

export const Route = createFileRoute('/_auth/spaces/')({
  component: SpacesPage,
});
